module.exports = __webpack_public_path__ + "static/media/sqlserver.c746da50.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/Skills/images/sqlserver.png
// module id = 125
// module chunks = 0